<template>
    <div>
        <v-col cols="12">
            <v-card class="mx-auto my-12" max-width="1000">
                <v-card-title class="text-x1">
                    <span class="mt-3">ดาวน์โหลดใบงาน HP Onsite Services</span>
                </v-card-title>

                <v-card-title>
                    <v-row>
                        <v-col cols="12" md="4" class="mar-t-10">
                            <v-text-field
                                rounded
                                dense
                                outlined
                                label="Case ID"
                                v-model="form.case_id"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4" class="mar-t-10">
                            <v-text-field
                                rounded
                                dense
                                outlined
                                label="Telephone No."
                                v-model="form.tel"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2" class="text-center mar-t-10">
                            <v-btn
                                @click="get_data()"
                                rounded
                                dense
                                color="primary"
                                :disabled="form.case_id == '' || form.tel == ''"
                            >
                                Search
                            </v-btn>
                            <v-btn
                                small
                                fab
                                class="ml-1"
                                v-if="form.case_id != '' || form.tel != ''"
                                @click="reset()"
                            >
                                <v-icon>mdi-rotate-left</v-icon>
                            </v-btn>
                        </v-col>

                        <v-col
                            cols="12"
                            class="text-center"
                            v-if="data_main.status == 'error'"
                        >
                            <span class="text-x3">
                                {{ data_main.message }}</span
                            >
                        </v-col>

                        <!-- Detail -->
                        <v-col
                            v-if="
                                data_main.status == 'ok' ||
                                    data_main.status == 'over'
                            "
                            cols="12"
                            md="6"
                            class="mar-t-15"
                        >
                            <span class="text-x2">
                                Case ID / ลำดับงานที่แจ้ง :
                            </span>
                            <span class="text-x22">
                                {{ data_main.case_id }}
                            </span>
                        </v-col>

                        <v-col
                            v-if="
                                data_main.status == 'ok' ||
                                    data_main.status == 'over'
                            "
                            cols="12"
                            class="mar-t-15"
                        >
                            <span class="text-x2">
                                Created / วัน/เวลา ที่รับแจ้ง :
                            </span>
                            <span class="text-x22">
                                {{ data_main.cdax_created }}
                            </span>
                        </v-col>
                        <v-col
                            v-if="
                                data_main.status == 'ok' ||
                                    data_main.status == 'over'
                            "
                            cols="12"
                            class="mar-t-15"
                        >
                            <span class="text-x2">
                                Title / รายละเอียดงาน :
                            </span>
                            <span class="text-x22">
                                {{ data_main.case_title }}
                            </span>
                        </v-col>
                        <v-col
                            v-if="
                                data_main.status == 'ok' ||
                                    data_main.status == 'over'
                            "
                            cols="12"
                            class="mar-t-15"
                        >
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th class="text-center">
                                                #
                                            </th>
                                            <th class="text-center">
                                                Solution / วิธีการแก้ไข
                                            </th>
                                            <th class="text-center">
                                                Onsite Date / วัน/เวลา
                                                ที่เช้ารับบริการ
                                            </th>
                                            <th
                                                class="text-center"
                                                v-if="data_main.status == 'ok'"
                                            >
                                                CSO
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(row,
                                            index) in data_main.subcase"
                                            :key="index"
                                        >
                                            <td class="text-center">
                                                {{ index + 1 }}.
                                            </td>
                                            <td>
                                                {{ row.solution }}
                                            </td>
                                            <td class="text-center">
                                                {{ row.onsite_date }}
                                            </td>
                                            <td
                                                class="text-center"
                                                v-if="data_main.status == 'ok'"
                                            >
                                                <v-btn
                                                    color="red"
                                                    class="white--text"
                                                    small
                                                    rounded
                                                    @click="
                                                        get_pdf(row.subcase_id)
                                                    "
                                                >
                                                    Dowload PDF
                                                </v-btn>
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                        <v-col
                            cols="12"
                            class="text-center mar-t-40"
                            v-if="
                                data_main.status == 'ok' ||
                                    data_main.status == 'over'
                            "
                        >
                            <span class="text-x3">
                                {{ data_main.message }}
                            </span>
                        </v-col>
                    </v-row>
                </v-card-title>
            </v-card>
        </v-col>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    methods: {
        async get_data() {
            this.dialog_loading = true
            await axios
                .post(url + "hpi/search-cso/", this.form)
                .then((response) => {
                    this.data_main = response.data
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        reset() {
            this.form = {
                case_id: "",
                tel: "",
            }
            this.data_main = []
        },
        async get_pdf(id) {
            this.dialog_loading = true
            await axios({
                url: url + "hpi/download-cso/" + id,
                responseType: "arraybuffer",
            }).then((response) => {
                this.dialog_loading = false
                let blob = new Blob([response.data], {
                        type: "application/pdf",
                    }),
                    url = window.URL.createObjectURL(blob)

                window.open(url)
            })
        },
    },
    data() {
        return {
            data_main: [],
            dialog_loading: false,
            form: {
                case_id: "",
                tel: "",
            },
        }
    },
}
</script>

<style scoped>
.text-x1 {
    letter-spacing: 0.1em;
    font-size: 28px;
    color: #034257 !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
}
.text-x2 {
    letter-spacing: 0.1em;
    font-size: 15px;
    color: #163563 !important;
    font-weight: bold;
}
.text-x22 {
    letter-spacing: 0.1em;
    font-size: 16px;
    color: #2573e7 !important;
}
.text-x3 {
    letter-spacing: 0.1em;
    font-size: 15px;
    color: #f32727 !important;
    font-weight: bold;
}
</style>
